import { ShieldCheck, Award, Sparkles, Infinity as InfinityIcon } from "lucide-react";
import { CountUp } from "@/components/CountUp";

const platforms = [
  "Baselinker",
  "Shopify",
  "Shoper",
  "PrestaShop",
  "ShopGold",
  "SellAsist",
  "Allegro",
  "Amazon",
  "eBay",
  "DPD",
  "InPost",
  "DHL",
];

type Stat =
  | { type: "count"; value: number; suffix: string; label: string; icon: typeof Sparkles }
  | { type: "text"; text: string; label: string; icon: typeof Sparkles };

const stats: Stat[] = [
  { type: "text", text: "Wieloletnie", label: "Doświadczenie w e-commerce", icon: InfinityIcon },
  { type: "count", value: 98, suffix: "%", label: "Zadowolonych klientów", icon: Award },
  { type: "count", value: 24, suffix: "h", label: "Średni czas reakcji", icon: ShieldCheck },
];

export function TrustBar() {
  return (
    <section className="relative border-y border-border/40 bg-gradient-to-b from-background via-muted/20 to-background py-16">
      <div className="mx-auto max-w-7xl px-6">
        <div className="text-center">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-xs font-medium uppercase tracking-wider text-primary">
            <ShieldCheck className="h-3.5 w-3.5" />
            Sprawdzony partner e-commerce
          </div>
          <h2 className="mt-2 font-display text-2xl font-semibold md:text-3xl">
            Liczby, które <span className="text-gradient">mówią same za siebie</span>
          </h2>
        </div>

        {/* Stats */}
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {stats.map((stat, i) => {
            const Icon = stat.icon;
            const isText = stat.type === "text";
            return (
              <div
                key={stat.label}
                className="group relative overflow-hidden rounded-2xl border border-border/60 bg-card/40 p-5 transition-all hover:border-primary/40 hover:shadow-[var(--shadow-elegant)]"
              >
                <div className="absolute -right-6 -top-6 h-20 w-20 rounded-full bg-primary/10 blur-2xl transition-opacity group-hover:opacity-100" />
                {isText ? (
                  <div className="pulse-glow mb-3 inline-flex">
                    <Icon className="h-5 w-5 text-primary" />
                  </div>
                ) : (
                  <Icon className="mb-3 h-5 w-5 text-primary" />
                )}
                <div className="font-display text-3xl font-bold md:text-4xl">
                  {stat.type === "count" ? (
                    <CountUp end={stat.value} suffix={stat.suffix} duration={1800} />
                  ) : (
                    <span className="text-gradient">{stat.text}</span>
                  )}
                </div>
                <p className="mt-1 text-xs text-muted-foreground md:text-sm">{stat.label}</p>
              </div>
            );
          })}
        </div>

        {/* Platform marquee logos */}
        <div className="mt-12">
          <p className="mb-5 text-center text-xs uppercase tracking-[0.2em] text-muted-foreground">
            Wdrażam i integruję
          </p>
          <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]">
            <div className="flex w-max animate-[marquee_40s_linear_infinite] gap-3">
              {[...platforms, ...platforms].map((name, i) => (
                <div
                  key={`${name}-${i}`}
                  className="flex shrink-0 items-center gap-2 rounded-full border border-border/60 bg-card/60 px-5 py-2.5 text-sm font-medium text-foreground/80"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-primary" />
                  {name}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
